export const MarkupStorageKey = 'markup';
